/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import Change from '../../../components/Change/Change';
import TinyEditableContent from '../../../components/TinyEditableContent/TinyEditableContent';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol5ModelDate } from '../../../core/models/tables';

interface IUkPeakPricesTable {
  data: TableCol5ModelDate;
  onEditCell: (data: any) => Promise<any>;
  onRemoveCustomPrice: (data: any) => Promise<any>;
}

export default function UkPeakPricesTable({
  data,
  onEditCell,
  onRemoveCustomPrice,
}: IUkPeakPricesTable): JSX.Element {
  const isAdmin = Boolean(sessionStorage.getItem('isAdmin') || false);
  const isClient = Boolean(sessionStorage.getItem('viewAsClient'));

  return (
    <div className="UkPeakPricesTable">
      <h3>UK Peak Prices</h3>
      <div className="table-container">
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th>
                Contract <br /> £/MWh
              </th>
              <th>{data.date1}</th>
              <th>{data.date2}</th>
              <th>
                Change <br /> D-1 vs D-2
              </th>
              <th>
                Current <br /> Offer (*)
              </th>
              <th>
                Change current <br /> vs D-1
              </th>
            </tr>
          </thead>
          <tbody>
            {data.pricesTable.map((row, index) => {
              if (row === null) {
                return null;
              }

              return (
                <tr key={index}>
                  <td>{row.col1}</td>
                  <td>{formatNumber(row.col2)}</td>
                  <td>{formatNumber(row.col3)}</td>
                  <td>
                    <Change value={row.col4} />
                  </td>
                  <td>
                    <TinyEditableContent
                      content={row.customLive || (row.col5 ? String(row.col5) : null) || '-'}
                      removable={row.idUpdate != null}
                      formatLevel={10}
                      disabled={!isAdmin || isClient}
                      save={(content) => {
                        return onEditCell({
                          value: content,
                          type: row.postIndex,
                          id: row.idUpdate,
                        });
                      }}
                      remove={() => onRemoveCustomPrice(row.idUpdate)}
                    />
                  </td>
                  <td>
                    <Change value={row.col6} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <p className="note">Note: Indicative Market Level Index</p>
      <p className="note">* Last Update: {data.liveDate}</p>
    </div>
  );
}
